__webpack_require__.p = "https://admin.ristoapp.com.br/";